// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"63dfe8dd","455":"0ef54c4d","488":"20c249e2"}[chunkId] + ".chunk.js";
};